import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Invite new Student(s)")
], -1)
const _hoisted_3 = { class: "card-body bg-light" }
const _hoisted_4 = { class: "mb-3 d-flex" }
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3 pb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "position-absolute top-0 end-0 mt-2 me-2 z-index-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        id: "student-create-form",
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        "initial-values": _ctx.formInitialValues
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_FieldArray, { name: "students" }, {
            default: _withCtx(({ fields, push, remove }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
                return (_openBlock(), _createElementBlock("fieldset", {
                  class: "InputGroup",
                  key: field.key
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("legend", null, "Student #" + _toDisplayString(idx + 1), 1),
                    _createElementVNode("button", {
                      class: "btn-close btn btn-sm flex-center transition-base",
                      onClick: ($event: any) => (remove(idx)),
                      disabled: fields.length <= 1
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Input, {
                      id: `student-create-first-name-${idx}`,
                      label: "First Name",
                      name: `students[${idx}].firstName`,
                      classes: "form-control",
                      placeholder: "First Name",
                      error: errors.firstName
                    }, null, 8, ["id", "name", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Input, {
                      id: `student-create-last-name-${idx}`,
                      label: "Last Name",
                      name: `students[${idx}].lastName`,
                      classes: "form-control",
                      placeholder: "Last Name",
                      error: errors.lastName
                    }, null, 8, ["id", "name", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Input, {
                      id: `student-create-email-${idx}`,
                      label: "Email",
                      name: `students[${idx}].email`,
                      classes: "form-control",
                      placeholder: "email@domain.com",
                      error: errors.email
                    }, null, 8, ["id", "name", "error"])
                  ]),
                  _hoisted_9
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary d-flex flex-center transition-base",
                  type: "button",
                  onClick: ($event: any) => (push(_ctx.defaultNewStudentValue))
                }, " Add Student + ", 8, _hoisted_11)
              ])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-primary d-block w-100 mt-3",
              type: "submit",
              name: "submit",
              textContent: _toDisplayString('Invite')
            }, null, 8, _hoisted_13)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}